import { ShippingConfidenceLevel } from '@/modules/product/types';

// shipping_confidence measures confidence, not risk: LOW = most at-risk seller
export function isShippingConfidenceAtRisk(
  level: ShippingConfidenceLevel | undefined
): boolean {
  return (
    level === ShippingConfidenceLevel.MEDIUM ||
    level === ShippingConfidenceLevel.LOW
  );
}
